<template>
  <el-form ref="requestForm" :model="formData" inline>
    <el-row>
      <el-form-item prop="inputValue" :rules="[{ required: formData.way === 'unity', validator: inputPriceValidator }]">
        <el-radio v-model="formData.way" label="unity" @change="handleWayChanged">统一{{ lableText }}：</el-radio>
        <div class="inputWarp">
          <AmountDigitInput
            v-model="formData.inputValue"
            :disabled="formData.way !== 'unity'"
            style="width: 260px"
            append="元"
            placeholder="请输入数字"
          />
        </div>
      </el-form-item>
    </el-row>
    <el-row>
      <el-form-item prop="formulaValue.percentage" :rules="[{ required: formData.way === 'formula', validator: percentageValidator }]">
        <el-radio v-model="formData.way" label="formula" @change="handleWayChanged">按公式修改：</el-radio>
        <div class="inputWarp">
          <el-select v-model="formData.formulaValue.priceMultiplier" :disabled="formData.way !== 'formula'" width="130px">
            <el-option v-for="option in priceMultiplierOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
            <!-- <el-option label="当前价格" value="now"></el-option>
            <el-option v-if="type === 'market' && platformType === 'pdd'" label="拼多多拼单价" value="pdd_multi_price"></el-option>
            <template v-if="type === 'market'">
              <el-option label="基础资料市场价" value="base_market"></el-option>
              <el-option label="基础资料销售价" value="base_sales"></el-option>
            </template>
            <template v-else>
              <el-option label="基础资料销售价" value="base_sales"></el-option>
              <el-option label="基础资料市场价" value="base_market"></el-option>
            </template>
            <el-option label="基础资料成本价" value="base_purchase"></el-option>
            <el-option label="基础资料基本售价" value="base_base_selling"></el-option> -->
          </el-select>
          <span class="operator">x</span>
          <el-input-digit
            v-model="formData.formulaValue.percentage"
            :precision="0"
            :max="999"
            nullable
            style="width: 80px"
            :disabled="formData.way !== 'formula'"
          >
            <span>%</span>
          </el-input-digit>
          <span class="operator">+</span>
          <AmountDigitInput
            v-model="formData.formulaValue.addValue"
            :disabled="formData.way !== 'formula'"
            nullable
            style="width: 80px"
            append="元"
            placeholder="0"
          />
          <span class="operator">-</span>
          <AmountDigitInput
            v-model="formData.formulaValue.subtractionValue"
            :disabled="formData.way !== 'formula'"
            nullable
            style="width: 80px"
            append="元"
            placeholder="0"
          />
        </div>
      </el-form-item>
    </el-row>
    <el-row>
      <el-form-item
        label-width="94px"
        label="分角处理："
        prop="formulaValue.centDime"
        :rules="[{ required: formData.formulaValue.formula === 'unity', validator: centDimeValidator }]"
      >
        <el-radio-group v-model="formData.formulaValue.formula" :disabled="formData.way !== 'formula'">
          <el-radio label="reserve">保留角和分(四舍五入) </el-radio>
          <el-radio label="erase_cent_dime">抹去分和角</el-radio>
          <el-radio label="erase_cent">抹去分</el-radio>
          <el-radio label="unity">统一修改为xx.</el-radio>
        </el-radio-group>
        <div class="inputWarp">
          <el-input-digit
            v-model.number="formData.formulaValue.centDime1"
            :disabled="formData.formulaValue.formula !== 'unity'"
            :precision="0"
            :maxlength="1"
            nullable
            style="width: 30px"
          >
          </el-input-digit>
          <el-input-digit
            v-model.number="formData.formulaValue.centDime2"
            :disabled="formData.formulaValue.formula !== 'unity'"
            :precision="0"
            :maxlength="1"
            nullable
            style="width: 30px"
          >
          </el-input-digit>
          元
        </div>
      </el-form-item>
    </el-row>
  </el-form>
</template>

<script>
import { cloneDeep } from 'lodash';
const formulaValue = {
  priceMultiplier: '',
  percentage: '100',
  addValue: '',
  subtractionValue: '',
  centDime: '',
  centDime1: 0,
  centDime2: 0,
  formula: 'reserve',
};

export default {
  name: 'EditPrice',
  props: {
    type: {
      type: String,
      default: 'sales',
    },
    platformType: {
      type: String,
      default: '',
    },
    priceMultiplierOptionsProp: {
      type: Array,
      default: () => [],
    },
    defaultPriceMultiplier: {
      type: String,
      default: 'now',
    },
  },
  data() {
    return {
      PLATFORM_SALES_PRICE_NAMES: {},
      PLATFORM_MARKET_PRICE_NAMES: {},
      formData: {
        way: 'unity',
        inputValue: '',
        formulaValue: {
          ...formulaValue,
          priceMultiplier: this.defaultPriceMultiplier || 'now',
        },
      },
    };
  },
  computed: {
    priceMultiplierOptions() {
      if (this.priceMultiplierOptionsProp.length) {
        return this.priceMultiplierOptionsProp;
      }
      const baseOptions = [
        { label: '当前价格', value: 'now' },
        this.type === 'market' && this.platformType === 'pdd' ? { label: '拼多多拼单价', value: 'pdd_multi_price' } : null,
        { label: '基础资料市场价', value: 'base_market' },
        { label: '基础资料销售价', value: 'base_sales' },
        { label: '基础资料成本价', value: 'base_purchase' },
        { label: '基础资料基本售价', value: 'base_base_selling' },
      ];
      return baseOptions.filter(Boolean);
    },
    lableText() {
      if (this.type === 'sales') {
        return this.PLATFORM_SALES_PRICE_NAMES[this.platformType];
      } else if (this.type === 'market') {
        return this.PLATFORM_MARKET_PRICE_NAMES[this.platformType];
      }
    },
  },
  watch: {
    formData: {
      handler(newVal, oldVal) {
        const { centDime1,centDime2,...reset } = newVal.formulaValue
        this.$emit('change', {...newVal,formulaValue:{...reset,centDime: (centDime1 || 0) * 10 + (centDime2 || 0)}});
      },
      deep: true,
    },
  },
  methods: {
    getFormData() {
      const { centDime1,centDime2,...reset } = this.formData.formulaValue
      let _formData = {...this.formData,formulaValue:{...reset,centDime: (centDime1 || 0) * 10 + (centDime2 || 0)}}
      return cloneDeep(_formData);
    },
    validate() {
      return new Promise(resolve => {
        this.$refs.requestForm.validate(valid => {
          resolve(valid);
        })
      })
    },
    handleWayChanged() {
      this.formData.inputValue = '';
      Object.assign(this.formData.formulaValue, { ...formulaValue, priceMultiplier: this.defaultPriceMultiplier || 'now' });
      this.$refs.requestForm.validateField(['inputValue', 'formulaValue.percentage', 'formulaValue.centDime']);
    },
    inputPriceValidator(rule, value, callback) {
      const { way, inputValue } = this.formData;
      if (way === 'unity' && !inputValue) {
        return callback(new Error(`请填写统一${this.lableText}`));
      }
      return callback();
    },
    percentageValidator(rule, value, callback) {
      const { way, formulaValue } = this.formData;
      const { percentage = '' } = formulaValue;
      if (way !== 'formula') {
        return callback();
      }
      if (percentage === '') {
        return callback(new Error(`请填写公式百分比`));
      }
      return callback();
    },
    centDimeValidator(rule, value, callback) {
      const { formulaValue } = this.formData;
      const { formula, centDime,centDime1,centDime2 } = formulaValue;
      let newCentDime = (centDime1 || 0) * 10 + (centDime2 || 0)
      if (formula === 'unity' && typeof newCentDime !== 'number') {
        return callback(new Error(`请填写分角值`));
      }
      return callback();
    },
  },
  async mounted() {
    // 动态导入常量，否则在编辑弹窗使用时会存在循环依赖
    try {
      const { PLATFORM_SALES_PRICE_NAMES, PLATFORM_MARKET_PRICE_NAMES } = await import('@/components/prod/center/dialogs/EditDialog-init');
      this.PLATFORM_SALES_PRICE_NAMES = cloneDeep(PLATFORM_SALES_PRICE_NAMES);
      this.PLATFORM_MARKET_PRICE_NAMES = cloneDeep(PLATFORM_MARKET_PRICE_NAMES);
    } catch (error) {
      console.error('Failed to load platform constants:', error);
    }
  },
};
</script>

<style lang="scss" scoped>
.inputWarp {
  display: inline-block;
  height: 100%;
  .operator {
    width: 16px;
    display: inline-block;
    text-align: center;
  }
}
</style>